import { useRef, useState } from "react";
import { Upload } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

export const ImageUpload = ({ multiple = false, onUploaded, label = "Upload image", testid }) => {
  const inputRef = useRef(null);
  const [progress, setProgress] = useState(null); // { done, total } while uploading

  const handleFiles = async (fileList) => {
    const files = Array.from(fileList || []);
    if (!files.length) return;
    setProgress({ done: 0, total: files.length });
    let ok = 0;
    for (const file of files) {
      try {
        const form = new FormData();
        form.append("file", file);
        const { data } = await api.post("/admin/upload", form);
        onUploaded(data.url);
        ok += 1;
      } catch (err) {
        toast.error(`${file.name}: ${formatApiErrorDetail(err.response?.data?.detail)}`);
      }
      setProgress({ done: ok, total: files.length });
    }
    if (ok) toast.success(ok === 1 ? "Image uploaded" : `${ok} images uploaded`);
    setProgress(null);
    if (inputRef.current) inputRef.current.value = "";
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept="image/jpeg,image/png,image/webp,image/gif"
        multiple={multiple}
        className="hidden"
        data-testid={`${testid}-input`}
        onChange={(e) => handleFiles(e.target.files)}
      />
      <button
        type="button"
        data-testid={testid}
        disabled={!!progress}
        onClick={() => inputRef.current?.click()}
        className="inline-flex items-center gap-2 border border-line px-4 py-2 text-[11px] tracking-[0.12em] uppercase text-smoke hover:border-ink hover:text-ink transition-colors disabled:opacity-50"
      >
        <Upload size={13} />
        {progress ? `Uploading ${progress.done + 1} of ${progress.total}…` : label}
      </button>
    </>
  );
};
